// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3YuSP","gfeWrapper":"CalendarEvent_gfeWrapper__2B9Bs"};